import { Rectangle, Texture } from 'pixi.js';
import { CharacterInputResource, CharacterResource } from '../interface';

class ResourceLoader {
  private static textures: Record<string, Array<Texture>> = {};

  private static has(key: string): boolean {
    return !!ResourceLoader.textures[key];
  }

  public static loadGridTexture(src: string, width: number, height: number): Array<Texture> {
    if (!this.has(src)) {
      const baseTexture = Texture.from(src).baseTexture;
      const textureColumn = baseTexture.width / width;
      const textureRows = baseTexture.height / height;

      this.textures[src] = new Array(textureColumn * textureRows).fill(true).map((_v, i) => {
        const [x, y] = [i % textureColumn, Math.floor(i / textureColumn)];
        const texture: Texture = new Texture(baseTexture, new Rectangle(x * width, y * height, width, height));

        texture.defaultAnchor.set(0, 0);

        return texture;
      });
    }

    return this.textures[src];
  }

  public static loadCharacter<T>(resource: CharacterInputResource<T>): CharacterResource<T> {
    if (!ResourceLoader.has(resource.name)) {
      const baseTexture = Texture.from(resource.texture).baseTexture;

      ResourceLoader.textures[resource.name] = resource.frames.map((frame) => {
        const texture: Texture = new Texture(baseTexture, new Rectangle(frame.x, frame.y, frame.w, frame.h));

        texture.defaultAnchor.set(frame.anchor.x, frame.anchor.y);

        return texture;
      });
    }

    const characterResource: CharacterResource<T> = {
      states: resource.states,
      statefulAnimation: {},
    };

    for (const state in resource.statefulAnimation) {
      characterResource.statefulAnimation[state] = {
        textures: resource.statefulAnimation[state].textures.map(
          (index) => ResourceLoader.textures[resource.name][index]
        ),
        offset: { x: 0, y: 0 },
        animationSpeed: resource.statefulAnimation[state].animationSpeed,
        loop: resource.statefulAnimation[state].loop,
      };
    }

    return characterResource;
  }
}

export default ResourceLoader;
